<template>
  <v-card flat class="px-5">
    <v-row class="pb-0">
      <v-col cols="8" md="8">
        <v-card flat style="color: #f2f3f9">
          <v-text-field
            flat
            background-color="#F6F8FC"
            solo
            class="feild"
            prepend-inner-icon="mdi-magnify"
            label="Search.."
            v-model="search"
            @input="Filter"
            single-line
          >
          </v-text-field>
        </v-card>
      </v-col>
    </v-row>

    <v-card flat class="mt-8">
      <v-row>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">USD - $</span></div>
        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">ARS - ARS$</span></div>
        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">AUD - A$</span></div>
        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div><span class="style_text_h">MXN - Mex$</span></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" class="mb-9">
          <div><span class="style_text_h">USD - $</span></div>
        </v-col>
        <v-col cols="12" md="3" class="mb-9">
          <div><span class="style_text_h">ARS - ARS$</span></div>
        </v-col>
        <v-col cols="12" md="6" class="mb-9">
          <div>
            <span class="style_text_h">Show all currencies available</span>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
export default {};
</script>

<style scoped>
.style_text_h {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.feild {
  background-color: #f6f8fc;
  border: 1px solid #f2f3f9;

  border-radius: 6px;
  height: 50px;
}
</style>